import { useEffect, useState } from 'react';
import { WindowLocation, useLocation } from '@reach/router';

const pageSize: number = parseInt(process.env.REACT_APP_PAGINATION_PAGE_SIZE || '32', 10);

interface StateLocation extends WindowLocation {
    state: Record<string, any>;
}

type Config = {
    limit: number;
    cacheKey: string;
};

const defualtConfig: Config = {
    limit: pageSize,
    cacheKey: '',
};

const toPaginationObject = <A>(arr: A[], limit: number, page: number, cacheKey?: string) => ({
    cacheKey,
    list: arr.slice((page - 1) * limit, page * limit),
    page,
    pageCount: Math.ceil(arr.length / limit),
});

const getCurrentPage = (url: string) => {
    const match = url.match(/(&?page=|\/)([0-9]+)(\/?)$/);

    if (match) {
        return parseInt(match[2], 10);
    }
};

const usePagination = <A>(arr: A[] = [], config = {}) => {
    const location = useLocation() as StateLocation;

    const [pagination, setPagination] = useState<any>({});

    const { limit, cacheKey } = { ...defualtConfig, ...config };

    useEffect(() => {
        if (pagination.cacheKey && cacheKey !== pagination.cacheKey) {
            setPagination(toPaginationObject(arr, limit, 1, cacheKey));
        }
    }, [cacheKey]);

    const currentPage = getCurrentPage(`${location.pathname}${location.search}`) || 1;

    return pagination.page ? pagination : toPaginationObject(arr, limit, currentPage, cacheKey);
};

export default usePagination;
